export default __webpack_public_path__ + "static/media/business-news.00a834f3.png";